export enum AppVersionPlatform {
  ANDROID = "android",
  IOS = "ios",
}

export type AppVersion = {
  id: string;
  platform: AppVersionPlatform;
  rawVersion: string;
  version: string;
  buildNumber: string;
  mustUpdate: boolean;
  deprecated: boolean;
  createdAt: number;
};
export type CreateAppVersion = Omit<AppVersion, "id" | "createdAt">;
